module.exports = __webpack_public_path__ + "static/media/RejectButton.3ba9f5f2.svg";